import { render, staticRenderFns } from "./ContactBookDataTable.vue?vue&type=template&id=c0d980a4"
import script from "./ContactBookDataTable.vue?vue&type=script&lang=js"
export * from "./ContactBookDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports